import axiosInstance from 'interceptor/axiosInstance';
import { MetaData } from 'models/MetaData/metaData.model';
import { useState } from 'react';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import { deserialize } from 'serializr';

const CreateProductsService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [products, setProducts] = useState<MetaData[]>([]);
  const [fieldsMap, setFieldsMap] = useState<Map<string, boolean>>();

  const getProductsMeta = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(ApiRoutes.PRODUCTS_META);
      const products = deserialize(
        MetaData,
        response.data.products
      ) as MetaData[];
      setProducts(products);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getFieldsList = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        ApiRoutes.CREATE_PRODUCT_FIELDS_META
      );
      const fields = deserialize(MetaData, response.data.fields) as MetaData[];
      const fieldMap = new Map<string, boolean>();
      fields.forEach(field => {
        fieldMap.set(field.key ?? '', field.isEditable ?? false);
      });
      setFieldsMap(fieldMap);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    products,
    fieldsMap,
    getProductsMeta,
    getFieldsList,
  };
};

export default CreateProductsService;
